import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Box, IconButton } from '@material-ui/core';
import { ChatActiveIcon, ChatInactiveIcon } from 'on_web/assets/iconsList';

export default function AssessmentSectionTitle(props) {
  const useStyles = makeStyles(theme => ({
    title: {
      fontFamily: 'Museo-500',
      fontSize: 18,
      lineHeight: 1.19,
      color: '#2a343f',
      textTransform: 'uppercase',
      paddingTop: '20px',
      textAlign: 'center',
      paddingLeft: '20px',
    },
  }));

  const classes = useStyles();

  return (
    <Grid container direction="row" justify="space-between" alignItems="center">
      <Grid item>
        <Box
          className={classes.title}
          display={props.isDesktop ? 'flex' : 'block'}
          textAlign={props.isDesktop ? 'left' : 'center'}
        >
          <span>{props.title}</span>
        </Box>
      </Grid>
      {props.showChatIcon && (
        <Grid item>
          <IconButton onClick={event => props.onChatIconClick(event)}>
            {props.hasUnreadMessages ? (
              <ChatActiveIcon fontSize="small" />
            ) : (
              <ChatInactiveIcon fontSize="small" />
            )}
          </IconButton>
        </Grid>
      )}
    </Grid>
  );
}

AssessmentSectionTitle.propTypes = {
  /**
   * Indicates whether title is for desktop resolution.
   */
  isDesktop: PropTypes.bool.isRequired,

  /**
   * Text to display as title.
   */
  title: PropTypes.string.isRequired,
};
